'use client';

import * as React from 'react';
import { BaseCustomerAccountsEnabledProvider, BaseCustomerProvider } from '~shared/segments/CustomerAccounts';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * This is just an empty provider to be able to use the `useCustomerCtx` hook in the shared form screen components.
 * Currently, the waiter app does not have customer accounts enabled, so the customer context is not available.
 * However, it is possible that in the future, the customer account will be required in the waiter as well,
 * this solution opens that option much more easily.
 *
 * Normally loads and provides customer information (name, phone number, email, addresses etc.).
 * If customer account feature is disabled, provides `null` as a value.
 */
export var CustomerProvider = function CustomerProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(BaseCustomerAccountsEnabledProvider, {
    areCustomerAccountsEnabled: false,
    children: /*#__PURE__*/_jsx(BaseCustomerProvider, {
      value: null,
      children: children
    })
  });
};